import { render, staticRenderFns } from "./SiteConfig.vue?vue&type=template&id=1f396a5c&scoped=true&lang=pug"
import script from "./SiteConfig.vue?vue&type=script&lang=js"
export * from "./SiteConfig.vue?vue&type=script&lang=js"
import style0 from "./SiteConfig.vue?vue&type=style&index=0&id=1f396a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f396a5c",
  null
  
)

export default component.exports